export function Timeline2025({isOpen}){

    return ( 

    <div
        style={{
          display: "flex",

          listStyle: 'none',
          overflow: 'hidden',
          maxHeight: isOpen ? '10000px' : '0',
          transition: 'max-height 0.5s ease',
          width: "100%",
          justifyContent: "center"
          }}
      >
        <div className="table-container">
          <table>
            <tbody>
            <tr>
              <td className="year normal-glow-text">Dec 2025</td>
              <td>
                <h3 >Full Stack Developer & Tech Lead @</h3>
                <div className="mobile-container">
                  <h3 className="para-spacer">Nivotutoring</h3>
                  <span className="mobile-year-para normal-glow-text">
                    Dec 2025
                  </span>
                </div>

                <ul>
                  <li className="normal-glow-text">
                    Led a development team as Tech Lead, contributing to project
                    planning and implementation.
                  </li>
                  <li className="normal-glow-text">
                    Configured and Deployed to Google Cloud from a Github
                    repository.
                  </li>
                  <li className="normal-glow-text">
                    Configured CI/CD pipelines and deployed the application to
                    Google Cloud directly from GitHub.
                  </li>
                </ul>
                <div className="bottom-icons">
                  <div className="icon-tool-tip" data-tooltip="Next.js">
                    <img
                      className="svg-glow"
                      src="/tech_icons/nextjs.svg"
                      alt="Next js"
                      height="32px"
                      width="32px"
                    />
                  </div>

                  <div className="icon-tool-tip" data-tooltip="GCP">
                    <img
                      className="svg-glow"
                      src="/tech_icons/cloud.svg"
                      alt="Cloud"
                      height="35px"
                      width="35px"
                    />
                  </div>
                  <div className="icon-tool-tip" data-tooltip="Node.js">
                    <img
                      className="svg-glow"
                      src="/tech_icons/node.svg"
                      alt="Node js"
                      height="32px"
                      width="32px"
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td className="year normal-glow-text">Jul 2025</td>
              <td>
                <a href="https://lfstutoring.org">
                  <h3>Freelance Front-End Developer @</h3>
                  <div className="mobile-container">
                    <h3 className="para-spacer">LFS Tutoring</h3>
                    <span className="mobile-year-para normal-glow-text">
                      Jul 2025
                    </span>
                  </div>
                </a>
                <ul>
                  <li className="normal-glow-text">
                    Met with client to gather requirements and user stories,
                    delivered iterative builds to match vision.
                  </li>
                  <li className="normal-glow-text">
                    Designed and deployed a custom branded front-end tailored to
                    an educator.
                  </li>
                  <li className="normal-glow-text">
                    Delivered website configuration and deployment punctually,
                    as planned.
                  </li>
                </ul>
                <div className="bottom-icons">
                  <div className="icon-tool-tip" data-tooltip="React">
                    <img
                      className="svg-glow"
                      src="/tech_icons/react.svg"
                      alt="React"
                      height="32px"
                      width="32px"
                    />
                  </div>
                  <div className="icon-tool-tip" data-tooltip="Server Configuration">
                    <img
                      className="svg-glow"
                      src="/tech_icons/server.svg"
                      alt="Server box"
                      height="32px"
                      width="32px"
                    />
                  </div>
                  <div className="icon-tool-tip" data-tooltip="Node.js">
                    <img
                      className="svg-glow"
                      src="/tech_icons/node.svg"
                      alt="Node js"
                      height="32px"
                      width="32px"
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td className="year normal-glow-text">Jun 2025</td>
              <td>
                <a href="https://heiwa-studio.eliyagop.com/">
                  <h3>Heiwa Studio</h3>
                  <div className="mobile-container">
                    <h3 className="para-spacer">Project</h3>
                    <span className="mobile-year-para normal-glow-text">
                      Jun 2025
                    </span>
                  </div>
                </a>

                <ul>
                  <li className="normal-glow-text">
                    Built full-stack PERN app with custom CMS and dynamic
                    store/map features.
                  </li>
                  <li className="normal-glow-text">
                    Constructed a RESTful API layer managing CRUD operations, implemented mobile-friendly UI components using React.
                  </li>
                </ul>
                <div className="bottom-icons">
                  <div className="icon-tool-tip" data-tooltip="React">
                    <img
                      className="svg-glow"
                      src="/tech_icons/react.svg"
                      alt="React js"
                      height="32px"
                      width="32px"
                    />
                  </div>
                  <div className="icon-tool-tip" data-tooltip="Server Configuration">
                    <img
                      className="svg-glow"
                      src="/tech_icons/server.svg"
                      alt="Server box"
                      height="32px"
                      width="32px"
                    />
                  </div>
                  <div className="icon-tool-tip" data-tooltip="Node.js">
                    <img
                      className="svg-glow"
                      src="/tech_icons/node.svg"
                      alt="Node.js"
                      height="32px"
                      width="32px"
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td className="year normal-glow-text">Jun 2025</td>
              <td>
                <h3>Self-Hosting with NGINX</h3>
                <div className="mobile-container">
                  <h3 className="para-spacer">Project</h3>
                  <span className="mobile-year-para normal-glow-text">
                    Jun 2025
                  </span>
                </div>
                <ul>
                  <li className="normal-glow-text">
                    The site you're viewing I initialized/configured a VPS
                    instance with NGINX to deploy my React site, and other
                    subdomain sites.
                  </li>
                  <li className="normal-glow-text">
                    Implemented security best practices on the VPS with SSL to
                    protect business-critical assets.
                  </li>
                  <li className="normal-glow-text">
                    Deployed and configured an email server for my domain.
                  </li>
                </ul>
                <div className="bottom-icons">
                  <div className="icon-tool-tip" data-tooltip="Nginx">
                    <img
                      className="svg-glow"
                      src="/tech_icons/nginx.svg"
                      alt="Nginx"
                      height="32px"
                      width="32px"
                    />
                  </div>
                  <div className="icon-tool-tip" data-tooltip="Server Config">
                    <img
                      className="svg-glow"
                      src="/tech_icons/server.svg"
                      alt="Server box"
                      height="32px"
                      width="32px"
                    />
                  </div>
                  <div className="icon-tool-tip" data-tooltip="Email Server">
                    <img
                      className="svg-glow"
                      src="/tech_icons/email.svg"
                      alt="Email letter"
                      height="37px"
                      width="37px"
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td className="year normal-glow-text">Jan 2025</td>
              <td className="table-card non-icon-spacer">
                <h3>The Oden Project</h3>
                <div className="mobile-container">
                  <h3 className="para-spacer">Education/Online Course</h3>
                  <span className="mobile-year-para normal-glow-text">
                    Jan 2025
                  </span>
                </div>
                <ul>
                  <li className="normal-glow-text">
                    A full-stack JavaScript curriculum with React,
                    Node.js/Express, and PostgreSQL through 27+ hands-on
                    projects
                  </li>
                  <li className="normal-glow-text">
                    Built responsive web applications using advanced HTML/CSS,
                    JavaScript, OOP principles, and React framework
                  </li>
                  <li className="normal-glow-text">
                    Developed full-stack applications integrating Node.js
                    backends, PostgreSQL databases, and React frontends
                  </li>
                </ul>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        </div>
        )
}
